var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 16H24V26L32.56 31.08L34 28.66L27 24.5V16ZM26 6C21.2261 6 16.6477 7.89642 13.2721 11.2721C9.89642 14.6477 8 19.2261 8 24H2L9.92 32.06L18 24H12C12 20.287 13.475 16.726 16.1005 14.1005C18.726 11.475 22.287 10 26 10C29.713 10 33.274 11.475 35.8995 14.1005C38.525 16.726 40 20.287 40 24C40 27.713 38.525 31.274 35.8995 33.8995C33.274 36.525 29.713 38 26 38C22.14 38 18.64 36.42 16.12 33.88L13.28 36.72C14.9429 38.4012 16.9244 39.7341 19.1084 40.6407C21.2924 41.5473 23.6353 42.0094 26 42C30.7739 42 35.3523 40.1036 38.7279 36.7279C42.1036 33.3523 44 28.7739 44 24C44 19.2261 42.1036 14.6477 38.7279 11.2721C35.3523 7.89642 30.7739 6 26 6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousCompleted);
export default __webpack_public_path__ + "static/media/previous-completed.81af2c02e82e69cc5fee52f8d980e889.svg";
export { ForwardRef as ReactComponent };